module.exports = __webpack_public_path__ + "static/media/success.519d711a.png";